import { render } from "./InputLongText.vue?vue&type=template&id=58c53954"
import script from "./InputLongText.vue?vue&type=script&lang=js"
export * from "./InputLongText.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__